"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const ManagerDropDown_1 = require("./ManagerDropDown");
const classes_1 = require("../../../../base/classes");
const CopyToClipboard_1 = require("../../../../../common/element/CopyToClipboard");
const SettingStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	flex-shrink: 0;
	position: relative;
	flex: 1;

	.dropdown-list {
		top: 50px;
	}

	.test-setting {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h5-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--h5-font-size, 16px);
		line-height: var(--h5-line-height, 24px);
		font-weight: var(--h5-font-weight, 700);
		position: relative;
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.setting-checkbox {
		flex-direction: column;
		gap: 12px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
	}

	.divider {
		background: var(--color-silver, #e6e8ed);
		flex-shrink: 0;
		height: 1px;
		position: relative;
		width: 100%;
	}

	.setting-container {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		label {
			height: 40px;
		}
	}

	.sms-settings {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
	}

	.sms-details {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		padding-left: 36px;

		.dropdown-live {
			width: 100px;
		}
	}

	.sms-auto-send {
		display: flex;
		gap: 12px;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
	}

	.spare-live {
		display: flex;
		flex-direction: column;
		gap: 13px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: 100%;
		position: relative;

		p {
			word-break: break-all;
			width: inherit;
		}
	}

	.live-add {
		display: flex;
		flex-direction: column;
		gap: 13px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: 100%;
		position: relative;
	}

	.count-down-set {
		display: flex;
		flex-direction: column;
		gap: 13px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: 100%;
		position: relative;
	}

	.name {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 28px);
		font-weight: var(--b4-font-weight, 400);
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	gap: 12px;
	padding-bottom: 24px;

	.setting-container {
		width: 100%;

		.mobile-xs {
			p {
				line-height: var(--b-l-small-line-height, 16px);
			}
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	gap: 12px;

	.setting-container {
		border-radius: 10px;
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 1px;
		padding: 24px;
	}
`;
const smsAutoSendList = [5, 10, 15, 20].map((minute) => ({
    id: String(minute),
    title: `${minute}분 전`,
}));
const liveTestAlarmList = [1, 3, 5, 10].map((minute) => ({
    id: String(minute),
    title: `${minute}분 전`,
}));
exports.SettingTable = react_1.default.memo(({ testData, isCustomCountDown, setIsCustomCountDown, countDownSet, setCountDownSet, spareLiveDatas, isSpareLive, setIsSpareLive, isModify, isSMSCheck, initSMSTime, setInitSMSTime, isOnlyStudentSms, setIsOnlyStudentSms, initLiveCheck, defaultLiveMember, initLiveMember, setIsSMSCheck, setInitLiveCheck, setLiveMember, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const classesId = (0, classes_1.getClassesId)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const [isLiveCheck, setIsLiveCheck] = react_1.default.useState(false);
    const [SMSMinutes, setSMSMinutes] = react_1.default.useState({
        id: 'select',
        title: 'common.select',
    });
    const [list, setList] = react_1.default.useState([]);
    const [dropdownList, setDropdownList] = react_1.default.useState([]);
    const [noMember, setNoMember] = react_1.default.useState(false);
    const [countdownList, setCountdownList] = react_1.default.useState([]);
    const noMoreAlarms = countdownList.filter(r => r.minuteId !== 'select').length >= liveTestAlarmList.length;
    const { data, refetch } = (0, server_1.useMemberInfo)({ class_id: classesId, level: ['02'] });
    const refetchList = react_1.default.useCallback((0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false }), [refetch]);
    (0, react_1.useEffect)(() => {
        if (isModify) {
            setSMSMinutes(smsAutoSendList.find((item) => item.id === String(initSMSTime)) || {
                id: 'select',
                title: 'common.select',
            });
        }
    }, [isModify, initSMSTime]);
    (0, react_1.useEffect)(() => {
        if (initLiveCheck) {
            setIsLiveCheck(initLiveCheck);
        }
    }, [initLiveCheck]);
    (0, react_1.useEffect)(() => {
        if (initLiveMember && initLiveMember.length > 0) {
            setList(initLiveMember.map(member => ({
                index: member,
                manager_id: member,
            })));
        }
    }, [initLiveMember]);
    (0, react_1.useEffect)(() => {
        refetchList();
    }, []);
    (0, react_1.useEffect)(() => {
        let drop_list = [{ id: 'select', title: 'common.select' }];
        if (data) {
            const { total_count, items } = data;
            if (total_count > 0) {
                drop_list = drop_list.concat(items.map((item) => ({
                    id: item.id,
                    title: item.nickname,
                })));
            }
        }
        setDropdownList(drop_list);
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (SMSMinutes.id === 'select') {
            if (isModify)
                return;
            setInitSMSTime(10);
        }
        else {
            setInitSMSTime(Number(SMSMinutes.id));
        }
    }, [SMSMinutes, isModify]);
    (0, react_1.useEffect)(() => {
        if (!isSMSCheck && isOnlyStudentSms) {
            setIsOnlyStudentSms(false);
        }
    }, [isSMSCheck, isOnlyStudentSms, setIsOnlyStudentSms]);
    (0, react_1.useEffect)(() => {
        if (initLiveMember.length === dropdownList.length - 1) {
            setNoMember(true);
        }
        else {
            setNoMember(false);
        }
    }, [dropdownList, initLiveMember]);
    (0, react_1.useEffect)(() => {
        if (defaultLiveMember && defaultLiveMember.length > 0) {
            setIsLiveCheck(true);
            setList(defaultLiveMember.map(member => ({
                index: member.id,
                manager_id: member.id,
            })));
        }
    }, [defaultLiveMember]);
    (0, react_1.useEffect)(() => {
        if (initLiveMember.length > 0)
            return;
        if (isLiveCheck && (!defaultLiveMember || defaultLiveMember.length === 0)) {
            setList([{ index: (0, moment_1.default)().unix().toString(), manager_id: 'select' }]);
        }
    }, [isLiveCheck, initLiveMember]);
    (0, react_1.useEffect)(() => {
        if (list.length <= 0) {
            setIsLiveCheck(false);
        }
        if (list.some(i => i.manager_id === 'select'))
            return;
        if (list.length === initLiveMember.length && list[0]?.manager_id === initLiveMember[0])
            return;
        const updatedLiveMembers = list
            .map(item => {
            if (item.manager_id !== 'select')
                return item.manager_id;
            return null;
        })
            .filter(Boolean);
        if (updatedLiveMembers === initLiveMember)
            return;
        if (updatedLiveMembers.length === 0) {
            setInitLiveCheck(false);
        }
        else {
            setInitLiveCheck(true);
        }
        setLiveMember(updatedLiveMembers);
    }, [list, initLiveMember]);
    const handlerLiveCheck = (id, checked) => {
        if (checked) {
            setIsLiveCheck(true);
            setInitLiveCheck(true);
        }
        else {
            setIsLiveCheck(false);
            setInitLiveCheck(false);
            setList([]);
            setLiveMember([]);
        }
    };
    const handlerCountDownCheck = (checked) => {
        if (checked) {
            setIsCustomCountDown(true);
            if (!countdownList.length) {
                setCountdownList([{ index: (0, moment_1.default)().unix().toString(), minuteId: 'select' }]);
            }
        }
        else {
            setIsCustomCountDown(false);
            setCountdownList([]);
            setCountDownSet([]);
        }
    };
    (0, react_1.useEffect)(() => {
        if (!isCustomCountDown)
            return;
        if (countDownSet && countDownSet.length > 0) {
            setCountdownList(countDownSet.map(num => ({
                index: `${num}-${(0, moment_1.default)().unix()}`,
                minuteId: String(num),
            })));
        }
        else {
            setCountdownList([{ index: (0, moment_1.default)().unix().toString(), minuteId: 'select' }]);
        }
    }, [isCustomCountDown]);
    (0, react_1.useEffect)(() => {
        const selected = countdownList
            .map(r => (r.minuteId !== 'select' ? Number(r.minuteId) : null))
            .filter((v) => v !== null);
        setCountDownSet(selected);
    }, [countdownList, setCountDownSet]);
    (0, react_1.useEffect)(() => {
        if (testData.length === 0) {
            setIsCustomCountDown(false);
            setCountdownList([]);
            setCountDownSet([]);
        }
    }, [testData]);
    const countdownExcludeList = (selfIndex) => {
        const others = countdownList
            .filter((_, i) => i !== selfIndex)
            .map(r => r.minuteId)
            .filter(id => id !== 'select');
        return others;
    };
    const isLiveRowLocked = (idx) => idx < list.length - 1 && list[idx]?.manager_id !== 'select';
    const isCountdownRowLocked = (idx) => idx < countdownList.length - 1 && countdownList[idx]?.minuteId !== 'select';
    return (react_1.default.createElement(SettingStyled, { "$isMobile": isMobile, "$isTablet": isTablet, className: "setting" },
        !isMobile && react_1.default.createElement("div", { className: "test-setting" }, t('conference.setting')),
        react_1.default.createElement("div", { className: "setting-container", style: { minWidth: !isMobile ? '430px' : '100%' } },
            react_1.default.createElement("div", { className: "sms-settings" },
                react_1.default.createElement("div", { className: "sms-auto-send" },
                    react_1.default.createElement(common_1.CheckBoxElement, { id: "sms", className: "setting-checkbox", checked: isSMSCheck, title: "conference.smsAutoSend", style: { flexDirection: 'row' }, handlerCheck: () => setIsSMSCheck(!isSMSCheck) }),
                    isSMSCheck && (react_1.default.createElement("div", { className: "sms-details" },
                        react_1.default.createElement(common_1.DropDown, { className: "dropdown-live", value: SMSMinutes, list: smsAutoSendList, setDropValue: setSMSMinutes }),
                        react_1.default.createElement(common_1.CheckBoxElement, { id: "onlyStudentSms", className: "setting-checkbox", checked: isOnlyStudentSms, title: "sendSMS.onlyStudentSend", style: { flexDirection: 'row' }, handlerCheck: () => setIsOnlyStudentSms(!isOnlyStudentSms) }))))),
            react_1.default.createElement("div", { className: "spare-live" },
                react_1.default.createElement(common_1.CheckBoxElement, { id: "spareLive", className: "setting-checkbox", checked: isSpareLive, title: "conference.spareLive", style: { flexDirection: 'row' }, handlerCheck: () => setIsSpareLive(!isSpareLive) }),
                isSpareLive && spareLiveDatas && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(CopyToClipboard_1.CopyToClipboard, { value: spareLiveDatas.stream_key, buttonText: 'Key \uBCF5\uC0AC' }),
                    react_1.default.createElement(CopyToClipboard_1.CopyToClipboard, { value: spareLiveDatas.publish_url, buttonText: 'Url \uBCF5\uC0AC' })))),
            react_1.default.createElement("div", { className: "live-add" },
                react_1.default.createElement(common_1.CheckBoxElement, { id: "liveQAndA", className: "setting-checkbox", checked: isLiveCheck, title: "conference.liveQAndA", style: { flexDirection: 'row' }, handlerCheck: (id, checked) => handlerLiveCheck(id, checked), isShowCheckBox: false }),
                isLiveCheck &&
                    list.map((item, index) => (react_1.default.createElement("div", { className: "field-global-001", key: item.index },
                        react_1.default.createElement(ManagerDropDown_1.ManagerDropDown, { dropdownList: dropdownList, excludeList: list.map(i => i.manager_id), defaultValue: {
                                id: item.manager_id,
                                title: dropdownList.find(dropItem => dropItem.id === item.manager_id)?.title || 'common.select',
                            }, handlerUpdateManager: value => {
                                if (!(noMember || isLiveRowLocked(index)) && list[index].manager_id !== value) {
                                    setList(prevList => {
                                        const newList = [...prevList];
                                        newList[index].manager_id = value;
                                        return newList;
                                    });
                                }
                            }, isDisable: noMember || isLiveRowLocked(index) }),
                        react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'mobile-xs' : 'xmd'}`, text: "conference.delete", styles: {
                                buttonWrap: {
                                    maxWidth: isMobile ? 60 : 80,
                                    maxHeight: isMobile && 38,
                                    boxShadow: 'unset',
                                },
                            }, onClick: () => setList(prevList => prevList.filter(prevItem => prevItem.index !== item.index)) }),
                        index === list.length - 1 && !noMember && (react_1.default.createElement(common_1.Button, { key: index, className: `btn_white ${isMobile ? 'mobile-xs' : 'xmd'}`, text: "common.add", styles: {
                                buttonWrap: {
                                    maxWidth: isMobile ? 60 : 80,
                                    maxHeight: isMobile && 38,
                                },
                            }, onClick: () => {
                                if (list.some(i => i.manager_id === 'select'))
                                    return;
                                setList(prevList => [
                                    ...prevList,
                                    {
                                        index: (0, moment_1.default)().unix().toString(),
                                        manager_id: 'select',
                                    },
                                ]);
                            } })))))),
            testData && testData.length > 0 && (react_1.default.createElement("div", { className: "count-down-set" },
                react_1.default.createElement(common_1.CheckBoxElement, { id: "countDownSet", className: "setting-checkbox", checked: isCustomCountDown, title: "conference.liveTestAlarm", style: { flexDirection: 'row' }, handlerCheck: (_id, checked) => handlerCountDownCheck(checked) }),
                isCustomCountDown &&
                    countdownList.map((row, idx) => {
                        const current = row.minuteId;
                        const value = current === 'select'
                            ? { id: 'select', title: 'common.select' }
                            : liveTestAlarmList.find(i => i.id === current) || {
                                id: 'select',
                                title: 'common.select',
                            };
                        return (react_1.default.createElement("div", { className: "field-global-001", key: row.index },
                            react_1.default.createElement(common_1.DropDown, { className: `dropdown-${isMobile ? 'mini' : 'live'}`, list: liveTestAlarmList, excludeList: countdownExcludeList(idx), value: value, setDropValue: (v) => {
                                    if (isCountdownRowLocked(idx))
                                        return;
                                    setCountdownList(prev => {
                                        const next = [...prev];
                                        next[idx] = { ...next[idx], minuteId: v.id };
                                        return next;
                                    });
                                }, styles: {
                                    itemWrap: {
                                        padding: '8px 10px',
                                        top: '45px',
                                        maxHeight: isMobile ? '200px' : '230px',
                                    },
                                }, isDisable: isCountdownRowLocked(idx) || noMoreAlarms }),
                            react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'mobile-xs' : 'xmd'}`, text: "conference.delete", styles: {
                                    buttonWrap: {
                                        maxWidth: isMobile ? 60 : 80,
                                        maxHeight: isMobile && 38,
                                        boxShadow: 'unset',
                                    },
                                }, onClick: () => setCountdownList(prev => {
                                    const next = prev.filter(it => it.index !== row.index);
                                    if (next.length === 0) {
                                        setIsCustomCountDown(false);
                                        setCountDownSet([]);
                                    }
                                    return next;
                                }) }),
                            idx === countdownList.length - 1 && !noMoreAlarms && (react_1.default.createElement(common_1.Button, { key: idx, className: `btn_white ${isMobile ? 'mobile-xs' : 'xmd'}`, text: "common.add", styles: {
                                    buttonWrap: {
                                        maxWidth: isMobile ? 60 : 80,
                                        maxHeight: isMobile && 38,
                                    },
                                }, onClick: () => {
                                    if (countdownList.some(i => i.minuteId === 'select'))
                                        return;
                                    if (noMoreAlarms)
                                        return;
                                    setCountdownList(prev => [
                                        ...prev,
                                        { index: (0, moment_1.default)().unix().toString(), minuteId: 'select' },
                                    ]);
                                } }))));
                    }))))));
});
